import { FC } from 'react';
import { useHistory } from 'react-router';

import quoteImg from 'assets/brand/notepad.png';
import Button from 'components/_core/Button';
import SunshineModal from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';
import { logEvent } from 'features/Analytics/analytics';

import * as routes from '../../../../../../routes';
import useArchiveQuote from '../../../mutations/useArchiveQuote';
import useDuplicateQuote from '../../../mutations/useDuplicateQuote';
import { useQuoteModals } from '../../';
import locales from './locales';

export interface ReviseModalProps {
  quoteId: string;
}

const ReviseModal: FC<ReviseModalProps> = ({ quoteId }) => {
  const history = useHistory();
  const { hideModal } = useQuoteModals();

  const [archiveQuote, { loading: isArchiving }] = useArchiveQuote(quoteId);
  const [duplicateQuote, { loading: isDuplicating }] = useDuplicateQuote({
    quoteId,
  });

  const onConfirm = async () => {
    const [, duplicateInvoiceResult] = await Promise.all([
      archiveQuote(),
      duplicateQuote(),
    ]);

    const duplicatedQuoteId =
      duplicateInvoiceResult?.data?.duplicateQuote.quote.quoteId;

    logEvent({
      name: 'Quote Archived And Duplicated',
      properties: { archivedQuoteId: quoteId, duplicatedQuoteId },
    });

    if (duplicatedQuoteId) {
      hideModal();
      history.push(routes.getQuote(duplicatedQuoteId));
    }
  };

  const loading = isArchiving || isDuplicating;

  return (
    <SunshineModal isOpen onClose={hideModal}>
      <SunshineModal.Header />

      <SunshineModal.Body>
        <SunshineModal.Body.Image src={quoteImg} />
        <SunshineModal.Title>{locales.title}</SunshineModal.Title>
        <Text>{locales.description}</Text>
      </SunshineModal.Body>

      <SunshineModal.Footer>
        <Button
          isDisabled={loading}
          onClick={hideModal}
          variant="inline-secondary"
        >
          {locales.cancel}
        </Button>

        <Button isLoading={loading} onClick={onConfirm}>
          {locales.confirm}
        </Button>
      </SunshineModal.Footer>
    </SunshineModal>
  );
};

export default ReviseModal;
